import {SelectProps} from "../Props";
import * as utils    from "../hooks/utils";

export default {
    computed:{
        selectProps() {
            let props = {}
            Object.keys(SelectProps).map(key => {
                props[key] = this.$props[key]
            })

            props.valueKey = this.dataKey
            props.filterMethod = this.setFilterMethod
            return props
        },
    },
    methods:{
        setFilterMethod(keyword = ''){
            if (this.filterMethod) this.filterMethod(keyword)

            this.$nextTick(() => {
                // let tree node expand only, same with tree filter
                this.$refs.tree.filter(keyword)
            })
        },
        onVisibleChange(visible){
            if(this.$listeners.visibleChange){
                this.$listeners.visibleChange(visible)
            }
            if (this.filterable && visible) {
                this.setFilterMethod()
            }
        },
        onChange(val){
            this.$emit(utils.INPUT_EVENT, val)
        }
    }
}
